import * as React from 'react';
import { createTheme } from '@mui/material/styles';
import type {} from '@mui/lab/themeAugmentation';
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
} from 'react-router-dom';
import { LinkProps } from '@mui/material/Link';

const LinkBehavior = React.forwardRef<
  any,
  Omit<RouterLinkProps, 'to'> & { href: RouterLinkProps['to'] }
>((props, ref) => {
  const { href, ...other } = props;
  // Map href (MUI) -> to (react-router)
  return <RouterLink ref={ref} to={href} {...other} />;
});

const palette = {
  primary: {
    main: '#439ad5',
    dark: '#246691',
  },
  secondary: {
    main: '#2e3c4f',
  },
  text: {
    primary: '#333333',
    secondary: '#646464',
  },
  background: {
    default: '#f5f5f5',
  },
  error: {
    main: '#C43247',
  },
};

const theme = createTheme({
  palette,
  components: {
    MuiLink: {
      defaultProps: {
        component: LinkBehavior,
      } as LinkProps,
    },
    MuiButtonBase: {
      defaultProps: {
        LinkComponent: LinkBehavior,
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
        outlined: {
          borderRadius: '8px',
          borderWidth: '2px',
          borderColor: palette.primary.dark,
          color: palette.primary.dark,
          '&:hover': {
            borderWidth: '2px',
            borderColor: palette.primary.main,
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '10px',
          boxShadow: '0 0 15px 0 rgba(0,0,0,0.12)',
        },
      },
    },
  },
  typography: {
    fontFamily: "'Open Sans', sans-serif",
    h2: {
      fontSize: '2rem', // 32px
      fontWeight: 300,
      marginBottom: 10,
    },
    h4: {
      fontSize: '0.75rem', // 12px
      fontWeight: 'bold',
    },
    h5: {
      fontWeight: 200,
    },
    h6: {
      fontWeight: 200,
    },
    caption: {
      fontSize: '0.6rem', // 9.6px
    },
  },
});

export default theme;
